// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3McZr","colMaxWidth":"Table_colMaxWidth__29yU0"};